import React from "react";
import Data from "../../component/data/index";

export function Dataa() {
  return (
   
      <Data />
  
  );
}
